// extracted by mini-css-extract-plugin
export default {"scrollArea":"ScrollArea_scrollArea__LtT6g"};